import React from "react";
import configManager from "../../singleton/ConfigManager";

function getConfigValue(obj, path) {
  return path.split('.').reduce((acc, key) => acc && acc[key], obj);
}

export default function withConfig(Component, configPath) {
  return function WrappedComponent(props) {
    const [configValue, setConfigValue] = React.useState(getConfigValue(configManager.config, configPath));

    React.useEffect(() => {
      const updatedConfigValue = getConfigValue(configManager.config, configPath);
      setConfigValue(updatedConfigValue);
    }, [configPath]); 

    
    if (configValue) {
      return <Component {...props} />;
    }
    return <></>; 
  };
} 